
import angular from 'angular';

import { ApuracoesPontoIndexController } from './index/apuracoesponto.index.controller';
import { ApuracaoPontoController } from './apuracaoponto/apuracaoponto.controller';
import { SaldoInicialController } from './saldo-inicial/saldo-inicial.controller';

import { SaldoInicialImportarModalController } from './saldo-inicial/modals/importar/saldo-inicial-importar.modal.controller';
import { SaldoInicialImportarModalService } from './saldo-inicial/modals/importar/saldo-inicial-importar.modal.service';

import { ApuracaoPontoComponent } from './apuracaoponto/apuracaoponto.component';
import { HistoricoApuracaoComponent } from './components/historico-apuracao/historico-apuracao.component';

import { ApuracoesPontoListRouting } from './apuracoesponto.routes';
import { ApuracoesPontoService } from './apuracoesponto.service';

export const ApuracoesPontoModule = angular.module('ApuracoesPontoModule', ['ui.router.state'])
    .controller('ApuracoesPontoIndexController', ApuracoesPontoIndexController)
    .controller('ApuracaoPontoController', ApuracaoPontoController)
    .controller('SaldoInicialController', SaldoInicialController)
    .controller('SaldoInicialImportarModalController', SaldoInicialImportarModalController)
    .service('ApuracoesPontoService', ApuracoesPontoService)
    .service('SaldoInicialImportarModalService', SaldoInicialImportarModalService)
    .component('apuracaoPontoComponent', ApuracaoPontoComponent)
    .component('historicoApuracaoComponent', HistoricoApuracaoComponent)
    .config(ApuracoesPontoListRouting)
    .name;
